import {
    ArrowDataTransferSquare,
    Building,
    CheckMarkCircle,
    DocumentValidation,
    JusticeScale,
    Money,
    UserMultiple,
} from "@/assets/icons";
import { Card } from "@/atoms";
import { AlfredStatusDataInterface } from "@/interfaces";
import { generateValidClassNameHandler } from "@/lib/utils";

const getIcon = (iconName?: string) => {
    switch (iconName) {
    case "accounts":
    case "building":
        return <Building className="size-5 text-primary" />;
    case "transactions":
    case "file":
        return <DocumentValidation className="size-5 text-gray-500" />;
    case "reconciliations":
    case "scale":
        return <JusticeScale className="size-5 text-green-500" />;
    case "balance":
    case "money":
        return <Money className="size-5 text-emerald-500" />;
    case "users":
        return <UserMultiple className="size-5 text-blue-500" />;
    case "activity":
        return <ArrowDataTransferSquare className="size-5 text-orange-500" />;
    case "success":
    case "check":
        return <CheckMarkCircle className="size-5 text-green-500" />;
    default:
        return null;
    }
};

const formatValue = (value: string | number) => {
    if (typeof value === "number") {
        // Format large numbers
        if (value >= 1000000) return `${(value / 1000000).toFixed(1)}M`;

        if (value >= 1000) return `${(value / 1000).toFixed(1)}K`;

        return value.toLocaleString();
    }
    return value;
};

export const AlfredStatusSummaryCard = ({
    className,
    data,
} : {
    className?: string,
    data: AlfredStatusDataInterface,
}) => {
    const cardContent = (
        <div className="flex divide-x">
            {data.stats.map((stat, idx) => {
                const icon = getIcon(stat.icon);
                return (
                    <div
                        className="flex flex-1 flex-col items-center px-3 py-1"
                        key={idx} // eslint-disable-line
                    >
                        {icon && <div className="mb-1">{icon}</div>}
                        <span className="text-xl font-bold">
                            {formatValue(stat.value)}
                        </span>
                        <span className="text-xs text-gray-500">
                            {stat.label}
                        </span>
                    </div>
                );
            })}
        </div>
    );

    return (
        <Card
            content={cardContent}
            contentClassName={!data.title ? "pt-4" : undefined}
            headerClassName="pb-2"
            title={data.title}
            className={generateValidClassNameHandler(
                "w-full border shadow-sm",
                className,
            )}
        />
    );
};
